// removed by extract-text-webpack-plugin
module.exports = {"addToHomeScreenPrompt":"addToHomeScreenPrompt__2oKXT","addToHomeScreenTextContainer":"addToHomeScreenTextContainer__2or_9","iconAndTextContainer":"iconAndTextContainer__3hiu5","iconContainer":"iconContainer__3CnfJ","appIcon":"appIcon__3jnXs","textContainer":"textContainer__Q3Tlf","actionContainer":"actionContainer__1zgXj","addToHomeBtn":"addToHomeBtn__274MK"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/addToHomeOption/style.css
// module id = EOZH
// module chunks = 323